











import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { RootGettersReturns, ActionsKeys } from '../../store/types';

@Component({})
export default class CanvasSidebar extends Vue {
  @Action(ActionsKeys.OPEN_DASHBOARD) openDashboard!: () => void;

  @Getter isGuest!: RootGettersReturns['isGuest'];

  mounted() {
    this.$root.$emit('updateValues', {});
  }
}
